import * as t from "io-ts";
import nullable from "./nullable";
import { uuidT } from "./uuid";
export const createStopUnitTypes = ({ decimal, }) => {
    const stopUnitContentT = t.strict({
        weight: nullable(decimal),
        width: nullable(decimal),
        length: nullable(decimal),
        height: nullable(decimal),
        volume: nullable(decimal),
        quantity: nullable(decimal),
        colli: nullable(decimal),
        description: t.string,
    });
    const addStopUnitT = t.intersection([
        stopUnitContentT,
        t.strict({
            stopUnitTemplateId: uuidT,
            pickupId: t.string,
            dropoffId: nullable(t.string),
        }),
        t.partial({
            id: t.string,
        }),
    ]);
    const addStopUnitTemplateT = t.intersection([
        stopUnitContentT,
        t.strict({ name: t.string, teamsIds: t.array(t.string) }),
    ]);
    const updateStopUnitTemplateT = t.intersection([
        stopUnitContentT,
        t.strict({ stopUnitTemplateId: t.string, teamsIds: t.array(t.string) }),
    ]);
    const stopUnitT = t.intersection([addStopUnitT, t.strict({ id: t.string })]);
    const stopUnitTemplateT = t.intersection([
        addStopUnitTemplateT,
        t.strict({ id: t.string, teamsIds: t.array(t.string), deleted: t.boolean }),
    ]);
    const stopUniteTemplatesT = t.array(stopUnitTemplateT);
    const stopUnitTemplatesT = t.array(stopUnitTemplateT);
    return {
        stopUnitT,
        addStopUnitT,
        addStopUnitTemplateT,
        updateStopUnitTemplateT,
        stopUnitTemplateT,
        stopUnitTemplatesT,
        stopUniteTemplatesT,
    };
};
//# sourceMappingURL=stop-unit.js.map